import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout";
import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import logo from "../../Assets/Logo.svg";
import { Send } from "@mui/icons-material";
import { useGlobal } from "../../Helper/Context/GlobalContext";
import axios from "axios";
import ErrorBox from "../../Components/ErrorBox";
import { LoadingButton } from "@mui/lab";
import Whatsapp from "../../Components/Whatsapp";
export default function JoinPartner() {
  const masukContext = useGlobal();
  const { setToOpenResponse, openErrorBox, setErrorServer } = masukContext;
  //============================================================== Loading Button
  const [loadingSts, setLoadingSts] = useState(false);
  function handleLoading() {
    setLoadingSts(true);
  }
  function handleCloseLoading() {
    setLoadingSts(false);
  }
  const initialForm = {
    full_name: "",
    nama_rd: "",
    alamat: "",
    email: "",
    tlp: "",
  };
  const [formPartner, setFormPartner] = useState(initialForm);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormPartner({
      ...formPartner,
      [name]: value,
    });
  };

  const [errors, setErrors] = useState(initialForm);

  const checkValidate = () => {
    const validationErrors = {};
    if (!formPartner.full_name) {
      validationErrors.full_name = "Masukan Username";
    }
    if (!formPartner.nama_rd) {
      validationErrors.nama_rd = "Masukan Nama Rumah Duka / Gedung";
    }
    if (!formPartner.alamat) {
      validationErrors.alamat = "Masukan Alamat";
    }
    if (!formPartner.tlp) {
      validationErrors.tlp = "Masukan Nomor Telepon";
    } else {
      const valid = /^[0-9]{1,13}$/.test(formPartner.tlp);
      !valid && (validationErrors.tlp = "Telepon Tidak Valid");
    }
    if (!formPartner.email) {
      validationErrors.email = "Masukan Email";
    } else {
      const valid =
        /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
          formPartner.email
        );
      !valid && (validationErrors.email = "Email Tidak Valid");
    }

    if (Object.keys(validationErrors).length > 0) {
      // If there are validation errors, set the error messages and don't submit the form
      handleCloseLoading();
      setErrors(validationErrors);
    } else {
      // Add logic to handle form submission (e.g., sending data to a server)
      handleSubmit();
    }
  };

  const handleSubmit = async () => {
    const url = process.env.REACT_APP_BASE_URL + "api/ContactUs/join-partner";

    await axios
      .post(url, formPartner, {})
      .then((response) => {
        setToOpenResponse({
          pathImage: "EmailSend.png",
          tittle: "Pendaftaran Terkirim",
          massage:
            "Tim kemitraan kami akan menghubungi Anda dalam waktu 24 jam..",
          pathButton: "/",
          nameButton: "Tutup",
        });
      })
      .catch((error) => {
        if (error.response.data.length < 100) {
          setErrorServer(error.response.data);
        } else {
          setErrorServer("Terjadi error saat mengirim pesan, Mohon coba lagi");
        }
        openErrorBox();
      })
      .finally(() => {
        handleCloseLoading();
      });
  };

  return (
    <Layout>
      <ErrorBox sx={{ mb: "3" }} />
      <Whatsapp />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          alignItems: "center",
          minHeight: 320,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "80%",
            alignItems: "center",
          }}
        >
          <Grid container spacing={2} mt={4}>
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Typography variant="h4" mb={4} textAlign="center">
                  Form Mitra
                </Typography>
                <img src={logo} alt="inmemoriam logo" width="100px" />
                <Typography variant="caption" fontSize="1em" textAlign="center">
                  Kami sangat antusias dan tidak sabar untuk melihat kolaborasi
                  luar biasa yang akan kita bangun bersama.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "end",
                  width: "100%",
                }}
              >
                <TextField
                  fullWidth
                  required
                  size="small"
                  id="full_name"
                  name="full_name"
                  onChange={handleInputChange}
                  label="Nama Lengkap"
                  variant="outlined"
                  value={formPartner.full_name || " "}
                  sx={{ mt: 2 }}
                  error={!!errors.full_name}
                  helperText={errors.full_name}
                />
                <TextField
                  fullWidth
                  required
                  size="small"
                  id="nama_rd"
                  name="nama_rd"
                  onChange={handleInputChange}
                  label="Nama rumah duka / gedung"
                  variant="outlined"
                  value={formPartner.nama_rd || " "}
                  sx={{ mt: 2 }}
                  error={!!errors.nama_rd}
                  helperText={errors.nama_rd}
                />
                <TextField
                  fullWidth
                  required
                  size="small"
                  id="alamat"
                  name="alamat"
                  onChange={handleInputChange}
                  label="Alamat"
                  variant="outlined"
                  value={formPartner.alamat || " "}
                  sx={{ mt: 2 }}
                  error={!!errors.alamat}
                  helperText={errors.alamat}
                />
                <TextField
                  fullWidth
                  required
                  size="small"
                  id="email"
                  name="email"
                  onChange={handleInputChange}
                  label="E-mail"
                  variant="outlined"
                  value={formPartner.email || " "}
                  sx={{ mt: 2 }}
                  error={!!errors.email}
                  helperText={errors.email}
                />
                <TextField
                  fullWidth
                  required
                  size="small"
                  id="tlp"
                  name="tlp"
                  onChange={handleInputChange}
                  label="Nomor Telepon"
                  variant="outlined"
                  value={formPartner.tlp || " "}
                  sx={{ mt: 2 }}
                  error={!!errors.tlp}
                  helperText={errors.tlp}
                />
                <LoadingButton
                  onClick={() => {
                    checkValidate();
                    handleLoading();
                  }}
                  size="small"
                  endIcon={<Send />}
                  loadingPosition="end"
                  loading={loadingSts}
                  variant="contained"
                  sx={{ my: 5, borderRadius: "99px", color: "white" }}
                >
                  Kirim
                </LoadingButton>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Layout>
  );
}
